module.exports = __webpack_public_path__ + "media/images/home/main/spele-9204d9ffd71ffa6856f423310b6970a4.png";